<template>
    <div id="subject">
        <v-breadcrumbs
            :items="[
                { text: 'Kodifikasi', to: { path: '/' } },
                { text: 'Pengaturan Bab' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Pengaturan Bab</h3>

        <v-card>
            <v-card-title> Daftar Mata Pelajaran </v-card-title>
            <v-divider />

            <v-card-text class="pa-0 ma-0">
                <v-container fluid>
                    <v-row no-gutters>
                        <v-col>
                            <v-text-field
                                v-model="query"
                                outlined
                                height="36px"
                                hide-details
                                small
                                dense
                                class="search_box"
                                placeholder="Ketik kata kunci dan tekan enter"
                            >
                                <template slot="prepend-inner">
                                    <svg
                                        style="margin-top: 10px !important"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                            fill="#073554"
                                        />
                                        <path
                                            d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                            fill="#073554"
                                        />
                                    </svg>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-list three-line style="min-height: none !important">
                <template>
                    <v-list-item
                        v-for="subject in filteredCards"
                        v-bind:key="subject.id"
                        @click="
                            $router.push({
                                path: '/topic-management/detail',
                                query: { subject_id: subject.id },
                            })
                        "
                    >
                        <v-list-item-avatar>
                            <v-img
                                :src="
                                    subject.picture
                                        ? subject.picture
                                        : '@/assets/blank.svg'
                                "
                                :style="
                                    $vuetify.breakpoint.smAndDown
                                        ? 'background-size:20px'
                                        : ''
                                "
                            ></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content class="pt-4 pb-6">
                            <v-list-item-title>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    {{ subject.name }}
                                </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Kode: {{ subject.code }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="d-flex align-self-center">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>
    </div>
</template>

<script>
import ItemBankService from "@/modules/itembank/services/itembank.js";

export default {
    name: "subject-management",

    data: function () {
        return {
            subjects: [],
            filteredCards: [],
            query: null,
            bgColors: ["bg-green", "bg-blue", "bg-purple", "bg-red"],
        };
    },

    watch: {
        query: function (val) {
            this.filteredCards = [];
            var filteredCards = this.subjects.filter(function (card) {
                return card.name.toLowerCase().includes(val.toLowerCase());
            });

            this.filteredCards = filteredCards;
        },
    },

    methods: {
        bgColor: function (id) {
            var index = id % 4;
            return this.bgColors[index];
        },
    },

    mounted: function () {
        var context = this;
        ItemBankService.getListMataPelajaran(function (response) {
            response.data.forEach(function (subject) {
                var data = {
                    id: subject.id,
                    code: subject.code,
                    picture: !subject.picture
                        ? "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png"
                        : subject.picture,
                    name:
                        subject.nama.length > 20
                            ? subject.nama.substring(0, 19) + "..."
                            : subject.nama,
                };

                context.subjects.push(data);
            });
        });
        this.filteredCards = this.subjects;
    },
};
</script>



// WEBPACK FOOTER //
// TopicManagement.vue?ec233894